import React from 'react';
import { Button } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../../actions';
import { useTranslation } from 'react-i18next';
import './Toolbar.css';

const ImageToolbar = props => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const showFilterPanel = useSelector(state => state.design.showFilterPanel);

  const showPanel = panel => {
    let show;
    if (showFilterPanel === panel) {
      show = 'off';
    } else {
      show = panel;
    }
    dispatch(designActions.showFilterPanel(show));
  };

  return (
    <div className="imageToolbar">
      <Button className="button text" title="Filters" onMouseDown={() => showPanel('filter')}>
        <span>{t('filter')}</span>
      </Button>
      <Button className="button text" title="Adjustment" onMouseDown={() => showPanel('adjust')}>
        <span>{t('adjust')}</span>
      </Button>
    </div>
  );
};

export default ImageToolbar;
